import { motion } from 'framer-motion';
import { cn } from '../../lib/utils';

// Progress Component
function Progress({
  value,
  max = 100,
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement> & {
  value: number;
  max?: number;
}) {
  return (
    <div
      className={cn(
        'relative h-2 w-full overflow-hidden rounded-full bg-gray-100',
        className,
      )}
      {...props}
    >
      <div
        className="h-full w-full flex-1 bg-primary transition-all"
        style={{ transform: `translateX(-${100 - (value / max) * 100}%)` }}
      />
    </div>
  );
}

// Avatar Wave Animation Component
function WaveAnimation({ isActive }: { isActive: boolean }) {
  return (
    <div className="absolute inset-0">
      {[1, 2, 3].map((i) => (
        <motion.div
          key={i}
          className="absolute inset-0 rounded-full border-2 border-primary"
          animate={
            isActive
              ? {
                  scale: [1, 1 + i * 0.1],
                  opacity: [0.6, 0],
                }
              : { scale: 1, opacity: 0 }
          }
          transition={{
            duration: 2,
            delay: i * 0.2,
            repeat: Infinity,
            ease: 'easeOut',
          }}
        />
      ))}
    </div>
  );
}

export { Progress };
